import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { X, ImagePlus } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const imgUrl = (path) => `${BACKEND}/api/files/${path}`;

export const MultiImageUploader = ({ value = [], onChange, label = "Additional photos", testid = "multi-image" }) => {
  const [uploading, setUploading] = useState(false);

  const handleFiles = async (files) => {
    const list = Array.from(files || []);
    if (!list.length) return;
    setUploading(true);
    const added = [];
    for (const file of list) {
      const fd = new FormData(); fd.append("file", file);
      try { const r = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }); added.push(r.data.path); }
      catch { toast.error(`Upload failed: ${file.name}`); }
    }
    if (added.length) { onChange([...(value || []), ...added]); toast.success(`${added.length} image${added.length > 1 ? "s" : ""} added`); }
    setUploading(false);
  };

  const remove = (path) => onChange((value || []).filter((p) => p !== path));

  return (
    <div data-testid={`${testid}-uploader`}>
      <Label className="text-xs font-bold uppercase tracking-wider text-slate-500">{label}</Label>
      {value?.length > 0 && (
        <div className="mt-2 grid grid-cols-4 gap-2">
          {value.map((path) => (
            <div key={path} className="relative group aspect-square rounded-lg border border-slate-200 overflow-hidden bg-slate-100" data-testid={`${testid}-thumb`}>
              <img src={imgUrl(path)} alt="" className="h-full w-full object-cover" />
              <button type="button" onClick={() => remove(path)} data-testid={`${testid}-remove`}
                className="absolute top-1 right-1 h-5 w-5 rounded-full bg-slate-900/70 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity hover:bg-red-600">
                <X className="h-3 w-3" />
              </button>
            </div>
          ))}
        </div>
      )}
      <label className="mt-2 flex items-center gap-2 text-sm text-slate-500 border border-dashed border-slate-300 rounded-lg px-3 py-2 cursor-pointer hover:border-lime-400 hover:text-slate-700 transition-colors">
        <ImagePlus className="h-4 w-4" />
        <span>{uploading ? "Uploading…" : "Add one or more images"}</span>
        <Input type="file" accept="image/*" multiple className="hidden" onChange={(e) => handleFiles(e.target.files)} data-testid={`${testid}-input`} />
      </label>
    </div>
  );
};
